import React from 'react'
import ReactDOM from 'react-dom/client'

import { initAnalitics } from 'Analitics'
import App from 'App'
import { initErrorMonitoring } from 'ErrorMonitoring'

initAnalitics()
initErrorMonitoring()

ReactDOM.createRoot(document.getElementById('app') as HTMLElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
